export default __webpack_public_path__ + "524e896f487119a0b8328ff494793910.svg";